import {
  SET_SELECTED,
  SET_PRODUCTS,
  SET_PRODUCTS_LOADING
} from '../actions/product'

export const MAX_SELECTED = 2000

const state = {
  isProductsLoading: false,
  products: [],
  selected: []
}

const getters = {
  getProducts: state => state.products,
  isProductsLoading: state => state.isProductsLoading,
  getSelected: state => state.selected,
  isSelectedPage: state => !!state.products.length && state.products.every((product) => state.selected.indexOf(product.id) !== -1),
  getProductPageLines: state => state.products.reduce((allLines, product) => {
    if (product.lines) {
      const { id, name } = product.lines
      if (id && !allLines[id]) {
        allLines[id] = name
      }
    }
    return allLines
  }, {})
}

const actions = {
  [SET_SELECTED]: ({ commit, state }, products) => {
    return new Promise((resolve, reject) => {
      if (Array.isArray(products) || typeof products === 'object') {
        let selected = [ ...state.selected ]
        if (Array.isArray(products)) {
          if (!products.length) {
            selected = []
          } else {
            const every = products.every((product) => selected.indexOf(product.id) !== -1)
            products.forEach((product) => {
              const foundIndex = selected.indexOf(product.id)
              if (every && foundIndex !== -1) {
                selected.splice(foundIndex, 1)
              } else if (!every && foundIndex === -1) {
                selected.push(product.id)
              }
            })
          }
        } else {
          const index = selected.indexOf(products.id)
          if (index === -1) {
            selected.push(products.id)
          } else {
            selected.splice(index, 1)
          }
        }
        if (selected.length > MAX_SELECTED) {
          selected.splice(MAX_SELECTED)
        }
        commit(SET_SELECTED, selected)
        resolve()
      } else {
        reject()
      }        
    })
  }
}

const mutations = {
  [SET_SELECTED]: (state, selected) => {
    state.selected = selected
  },
  [SET_PRODUCTS]: (state, products) => {
    state.products = products
  },
  [SET_PRODUCTS_LOADING]: (state, value) => {
    state.isProductsLoading = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
